import { useEffect, useRef, useState } from "react";

/**
 * Lightweight scroll progress hook.
 * Returns the page's vertical scroll position (px), updated via rAF.
 */
export function useScrollY() {
  const [y, setY] = useState(0);
  const raf = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      if (raf.current) return;
      raf.current = requestAnimationFrame(() => {
        setY(window.scrollY);
        raf.current = 0;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, []);

  return y;
}
